import { memo } from "react";

import { lazyWithPreload } from "@/utils/lazyPreload";
import { FlowProvider } from "@/utils/providers/FlowProvider";
import { FlowTypes } from "@/utils/providers/types";

const Main = lazyWithPreload(() => import("@/components/Main"));

// need to be here as both flow starts with Main component
Main.preload();

const FemaleFlow = ({ flowType = FlowTypes.Both }: { flowType?: FlowTypes }) => {
    return <FlowProvider flowType={flowType} />;
};

export default memo(FemaleFlow);
